module.exports = __webpack_public_path__ + "assets/shouji.7871e8d3.svg";